import { Button } from '@design-system/components/button/button';
import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';

export interface ConfirmRedirectModalProps {
  isOpen: boolean;
  type: 'content' | 'program' | null;
  saveChanges: () => void;
  redirect: () => void;
  cancel: () => void;
}

export const ConfirmRedirectModal: React.FC<ConfirmRedirectModalProps> = ({
  isOpen,
  type,
  saveChanges,
  redirect,
  cancel,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={cancel}
    title={
      type === 'program'
        ? 'Create your first program'
        : 'Create your first item'
    }
    modalClassName="w-full md:w-[670px]"
    centerContent={true}
  >
    <div className="flex flex-col gap-6">
      <Typography variant="body" size="large" fontWeight="normal">
        {type === 'program'
          ? 'You are about to leave this page to create your first Program in another tab. Do you want to save this offer as a draft?'
          : "You are about to leave this page to create your first 'Extra' item in another tab. Do you want to save this offer as a draft?"}
      </Typography>
      <div className="flex gap-4 justify-center">
        <Button
          variant="text"
          color="neutral"
          onClick={redirect}
          className="w-[220px]"
        >
          Leave without saving
        </Button>
        <Button color="neutral" onClick={saveChanges} className="w-[200px]">
          Save as draft
        </Button>
      </div>
    </div>
  </Modal>
);
